import React, { Component } from 'react';
import ProductImg1 from "../images/Maevelifestyle/product2.png"
import ProductImg2 from "../images/Maevelifestyle/product8.png"
import ProductImg3 from "../images/Maevelifestyle/product3.png"
import ProductImg4 from "../images/Maevelifestyle/product4.png"
import Cart from "../headerComponents/cartLokal"
import CartBtn from "../commonItem/addcartBtn"
import { elasticLink, elasticHostURL } from "../config";
import { pageHitAPICall } from '../services';
const AWS = require('aws-sdk');
const elasticsearch = require("elasticsearch");
AWS.config.region = 'us-west-1';
export default class Header extends Component {
    constructor(props) {
        super(props)
        this.state = {
            itemListingData: [],
            sizeId: '',
            sizeName: '',
            cmsizeId: '',
            brandQueryData: [],
            rowCount: [],
            sortActive: false,
            divPagination: '0',
            value: '',
            minPrice: '',
            maxPrice: '',
            isData: '1',
            popularItem: [],
            cartVisible: false
        };
        this.getCategory = this.getCategory.bind(this);
        this.itemLoad = this.itemLoad.bind(this);
        this.cartClick = this.cartClick.bind(this);
        this.quantity = this.quantity.bind(this);

    }
    componentDidMount() {
        this.getCategory()
        var sellerID = "";
        var moduleID = 12;
        var siteCategoryGroupId = "";
        if (window.sessionStorage.getItem('siteCategoryId') !== "0") {
            siteCategoryGroupId = window.sessionStorage.getItem('siteCategoryId');
        }
        else {
            sellerID = window.sessionStorage.getItem('sellerId')
        }
        pageHitAPICall(sellerID, moduleID, siteCategoryGroupId)
    }

    async getCategory(storeI, sortBy, brandId, minPrice, maxPrice, featureSearch, colorId, sizeId, category1Id, category2Id, category3Id, offset, max, keyWord) {
        let storeId = window.sessionStorage.getItem('storeId');
        const client = new elasticsearch.Client({
            host: elasticHostURL(),
            amazonES: {
                region: 'us-west-1',
                 //credentials: new AWS.Credentials(this.state.s3AccessKey, this.state.s3SecretKey)
            }
        });
        var fields = ['store_id'];
        var filters = [];
        var paramsVal = [storeId]
        for (var k = 0; k < fields.length; k++) {
            if (paramsVal[k] !== '*' && paramsVal[k] !== '') {
                var termq = { term: {} };
                termq.term[fields[k]] = paramsVal[k];
                filters.push(termq);
            }
        }
        var popularItemData;
        var totalCount
        var sortByFilter = [{ sort_order: "asc" }]
        const body = await client.search({
            index: elasticLink() + '-cm-commonitem-search',
            from: 0, size: 40,
            body: {
                query:
                {
                    bool: {
                        filter:
                        {
                            bool:
                            {
                                must: filters
                            }
                        }
                    }
                },
                sort: sortByFilter
            }
        })
        popularItemData = body.hits.hits
        totalCount = body.hits.total.value
        this.setItemObject(popularItemData, totalCount)
    }
    setItemObject(dataResult, totalCount) {
        var selectCommonItemCart = JSON.parse(localStorage.getItem('selectCommonItemCart'))
        var itemrelatedData = []
        if (dataResult.length > 0) {
            for (var i = 0; i < dataResult.length; i++) {
                var sizeArray = []
                if (dataResult[i]._source.item_size != null && dataResult[i]._source.item_size != '') {
                    var item_size = dataResult[i]._source.item_size.split(',')
                    var item_size_id = dataResult[i]._source.item_size_id.split(',')
                    var item_size_quantity = dataResult[i]._source.item_size_quantity.split(',')
                    var cm_ItemSizeId = dataResult[i]._source.cm_item_size_id.split(',')
                    for (var s = 0; s < item_size.length; s++) {
                        var sizeVal = {
                            sizeName: item_size[s],
                            sizeId: item_size_id[s],
                            sizeQuantity: item_size_quantity[s],
                            cmItemSizeId: cm_ItemSizeId[s]
                        }
                        sizeArray.push(sizeVal)
                    }
                }
                var cartLabel = 'ADD TO CART'
                var cartQuantity = 0;
                var isCartItemColorShow = ""
                var isCartItemOpenClass = ""
                var sizeId = ""
                var sizeName = ""
                var cmsizeId = ""
                var quantity = 1
                if (selectCommonItemCart !== null && selectCommonItemCart !== '' && selectCommonItemCart !== 'null') {
                    for (let n = 0; n < selectCommonItemCart.length; n++) {
                        if (selectCommonItemCart[n].itemId == dataResult[i]._source.item_id) {
                            cartQuantity = parseInt(cartQuantity) + parseInt(selectCommonItemCart[n].quantity)
                            isCartItemColorShow = "block"
                            isCartItemOpenClass = "cart_clk"
                            cartLabel = 'ADDED'
                            sizeId = selectCommonItemCart[n].sizeId
                            sizeName = selectCommonItemCart[n].sizeName
                            cmsizeId = selectCommonItemCart[n].cmItemSizeId
                            quantity = selectCommonItemCart[n].quantity
                        }
                    }
                }
                var itemData = [];
                itemData = {
                    s3_folder_name: dataResult[i]._source.s3_folder_name,
                    item_name: dataResult[i]._source.item_name,
                    item_id: dataResult[i]._source.item_id,
                    store_id: dataResult[i]._source.store_id,
                    item_master_id: dataResult[i]._source.item_master_id,
                    item_title: dataResult[i]._source.item_title,
                    item_image: dataResult[i]._source.item_image,
                    mrp: dataResult[i]._source.mrp,
                    net_amount: dataResult[i]._source.net_amount,
                    brand_name: dataResult[i]._source.brand_name,
                    available_quantity: dataResult[i]._source.available_quantity,
                    slug: dataResult[i]._source.slug,
                    is_offer: dataResult[i]._source.is_offer,
                    offer_text: dataResult[i]._source.offer_text,
                    item_size: dataResult[i]._source.item_size,
                    item_size_id: dataResult[i]._source.item_size_id,
                    hasContactUsWithoutPrice: dataResult[i]._source.hascontactuswithoutprice,
                    hasBuyOption: dataResult[i]._source.hasbuyoption,
                    item_size_quantity: dataResult[i]._source.item_size_quantity,
                    storeButtonName:
                        dataResult[i]._source.storebuttonname == null
                            ? ""
                            : dataResult[i]._source.storebuttonname,
                    sizeResult: sizeArray,
                    category: dataResult[i]._source.category_level2_name,
                    // isCart: isCart,
                    sizeId: '',
                    sizeName: sizeName,
                    cmsizeId: cmsizeId,
                    maxBuyCount: dataResult[i]._source.maxbuycount,
                    cartSize: cartQuantity,
                    isCartItemColorShow: isCartItemColorShow,
                    isCartItemOpenClass: isCartItemOpenClass,
                    cartLabel: cartLabel,
                    currencySymbol: dataResult[i]._source.currencysymbol,
                    colorId: dataResult[i]._source.colour_id,
                    quantity: 1
                }
                itemrelatedData.push(itemData)
            }
            this.setState({
                itemListingData: itemrelatedData,
                rowCount: totalCount,
                divPagination: '1',
                isData: '1',
            })
        }
        else {
            this.setState({
                isData: '0'
            });
        }
    }
    itemLoad() {
        let storeId = window.sessionStorage.getItem('storeId');
        let sortBySearch = (window.sessionStorage.getItem('sortBySearch') == null ? '' : window.sessionStorage.getItem('sortBySearch'));
        let searchKeyword = (window.sessionStorage.getItem('searchKeyword') == null ? '' : window.sessionStorage.getItem('searchKeyword'));
        let category1Id = (window.sessionStorage.getItem('category1Id') == null ? '' : window.sessionStorage.getItem('category1Id'));
        let category2Id = (window.sessionStorage.getItem('category2Id') == null ? '' : window.sessionStorage.getItem('category2Id'));
        let category3Id = (window.sessionStorage.getItem('category3Id') == null ? '' : window.sessionStorage.getItem('category3Id'));
        let brandSearch = (window.sessionStorage.getItem('brandSearch') == null ? '' : window.sessionStorage.getItem('brandSearch'));
        let hidMinSearch = (window.sessionStorage.getItem('hidMinSearch') == null ? '' : window.sessionStorage.getItem('hidMinSearch'));
        let hidMaxSearch = (window.sessionStorage.getItem('hidMaxSearch') == null ? '' : window.sessionStorage.getItem('hidMaxSearch'));
        let featureSearch = (window.sessionStorage.getItem('featureSearch') == null ? '' : window.sessionStorage.getItem('featureSearch'));
        let colorSearch = (window.sessionStorage.getItem('colorSearch') == null ? '' : window.sessionStorage.getItem('colorSearch'));
        let sizeSearch = (window.sessionStorage.getItem('sizeSearch') == null ? '' : window.sessionStorage.getItem('sizeSearch'));
        let offset = (window.sessionStorage.getItem('offset') == null ? 0 : window.sessionStorage.getItem('offset'));
        let max = (window.sessionStorage.getItem('max') == null ? 40 : window.sessionStorage.getItem('max'));
        this.getCategory(storeId, sortBySearch, brandSearch, hidMinSearch, hidMaxSearch, featureSearch, colorSearch, sizeSearch, category1Id, category2Id, category3Id, offset, max, searchKeyword)
    }
    sizeChange(event, index, data) {
        let finalfilter = data.filter((obj) => {
            return obj.sizeId === event
        })
        this.state.itemListingData[index].sizeId = event
        this.state.itemListingData[index].sizeName = finalfilter[0].sizeName
        this.state.itemListingData[index].cmsizeId = finalfilter[0].cmItemSizeId
        this.setState({
            itemListingData: this.state.itemListingData
        });
    }
    quantity(event, index) {
        this.state.itemListingData[index].quantity = event
        this.setState({
            itemListingData: this.state.itemListingData
        });
    }
    cartClick() {
        if (document.getElementById("globalSearchDiv") !== null) {
            document.getElementById("globalSearchDiv").style.display = "none";
        }
        if (!this.state.cartVisible) {
            document.addEventListener('click', this.cartOutsideClick, false);
        } else {
            document.removeEventListener('click', this.cartOutsideClick, false);
        }
        this.setState(prevState => ({
            cartVisible: !prevState.cartVisible,
        }));
    }
    render() {
        let cartLength = 0;
        if (localStorage.getItem('selectedCartProduct') !== null) {
            cartLength = parseInt(cartLength) + (JSON.parse(localStorage.getItem('selectedCartProduct')).length);
        }
        if (localStorage.getItem('selectRestaurantCart') !== null) {
            cartLength = parseInt(cartLength) + (JSON.parse(localStorage.getItem('selectRestaurantCart')).length);
        }
        if (localStorage.getItem('selectCommonItemCart') !== null) {
            cartLength = parseInt(cartLength) + (JSON.parse(localStorage.getItem('selectCommonItemCart')).length);
        }
        return (
            <div className='Product-img'>
                <div className="container-fluid px-5 pb-5">
                    <div className='sub-head mb-4'>Fragrances</div>
                    <div className="row">
                    {this.state.itemListingData.map((itemData, index) => (
                        <div className="col-12 col-lg-3 col-md-6">
                            <div className="product-list">
                                {console.log("lllllllllllllllllllllll",this.state.itemListingData)}
                                <div className="product-img">
                                <a href={"/cmItemProfile/"+itemData.item_id}>
                                    <img src={itemData.item_image} alt="ProductImg" className='img-fluid' />
                                    </a>
                                </div>
                                <div className="product-details">
                                    <div class="su_prod_cat">
                                        <p className='mb-0'>{itemData.item_name}</p>
                                        <span class="newPrice">{itemData.currencySymbol} {parseFloat(itemData.net_amount).toFixed(window.sessionStorage.getItem('decimalCount'))}</span>
                                      {itemData.net_amount < itemData.mrp &&
                                        <span class="oldPrice">{itemData.currencySymbol} {parseFloat(itemData.mrp).toFixed(window.sessionStorage.getItem('decimalCount'))}</span>
                                      }
                                        <p class="size-input mb-0">Size :  {itemData.item_size}</p>
                                        <div class="qty-div">Quantity:<input type="number" min={1} className=" form-control su_inputs qty-input" onChange={(e) => this.quantity(e.target.value, index)} value={itemData.quantity} /></div>
                                    </div>
                                    <div className={"su_cart_success vert-move"} id={"cartSuccessMessage" + itemData.item_id} style={{ display: 'none' }}>
                                                    <p className="mb-0">Successfully Added to Cart</p>
                                                </div>
                                    <div className='addtocart'>
                                    {/* <div className="su_addCartBtn mt-3"> */}
                                                    {/* <div> */}
                                                        <CartBtn
                                                            fromPage={"Listing"}
                                                            itemLoad={this.itemLoad}
                                                            sizeId={itemData.sizeResult[0]?.sizeId}
                                                            quantity={itemData.quantity}
                                                            sizeName={itemData.sizeResult[0]?.sizeName}
                                                            cmsizeId={itemData.sizeResult[0]?.cmItemSizeId}
                                                            cartLabel={itemData.cartLabel}
                                                            cartSize={itemData.cartSize}
                                                            itemId={itemData.item_id}
                                                            itemName={itemData.item_name}
                                                            storeId={itemData.store_id}
                                                            itemTitle={itemData.item_title}
                                                            brand={itemData.brand_name}
                                                            itemSize={itemData.sizeResult}
                                                            netAmount={itemData.net_amount}
                                                            mrp={itemData.mrp} itemImage={itemData.item_image}
                                                            index={itemData.item_id} itemMasterId={itemData.item_master_id}
                                                            maxBuyCount={itemData.maxBuyCount}
                                                            availableQuantity={itemData.available_quantity}
                                                            itemAddedColour="itemAddedColour"
                                                            qtyError="qtyError"></CartBtn>
                                                    {/* </div> */}
                                                {/* </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                      {this.state.cartVisible && (
                                    <div className="cartDiv Su_cartDiv" >
                                        <Cart cartClick={this.cartClick}></Cart>
                                    </div>
                                )}
                    </div>
                </div>
            </div>
        )
    }
}
